import { Error404 } from "../pages";
import routesClient from "./routes.client";
import routesSeller from "./routes.seller";
import { BasicLayout } from "../Layouts";

const routes = [
  ...routesClient,
  ...routesSeller,
  {
    path: "*",
    layout: BasicLayout,
    component: Error404,
  },
];

export default routes;
